import { Component, OnInit, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InputNumberModule } from 'primeng/inputnumber';
import { ApiService } from '../../../service/api/api.service';

@Component({
  selector: 'app-check',
  standalone: true,
  imports: [FormsModule, CommonModule, InputNumberModule],
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
})
export class CheckComponent implements OnInit {
  @Input() desiredPrivilege: number = 3;
numero: number | null = null;
  numeroSansEspaces: string = '';
  telephoneInvalide = false;
  utilisateur: any = {};
  password: string = '';
  nouvelUtilisateur: any = { prenom: '', nom: '', password: '' };
  currentStep: number = 1; // étape actuelle : 1 = numéro, 2 = login, 3 = création
  showPassword: boolean = false;
  showPasswordCreation: boolean = false;

  // 8 caractères min, 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial
  private passwordRegex: RegExp =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>_\-+=~`[\]/;'\\]).{8,}$/;

  constructor(
    public modal: NgbActiveModal,
    public api: ApiService,
  ) {}

  ngOnInit(): void {}
  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordCreation() {
    this.showPasswordCreation = !this.showPasswordCreation;
  }

  isPasswordValid(): boolean {
    return this.passwordRegex.test(this.nouvelUtilisateur.password || '');
  }
  // Étape 1 : vérifier le numéro
  submitNumero() {
  this.numeroSansEspaces = String(this.numero ?? '');

  if (this.numeroSansEspaces.length !== 9) {
    this.telephoneInvalide = true;
    return;
  }

  this.telephoneInvalide = false;


  this.api.taf_post(
    'utilisateur/get',
    { telephone: this.numeroSansEspaces },
    (reponse: any) => {
      if (reponse.status && reponse.data.length > 0) {
        this.utilisateur = { ...reponse.data, exists: true };
        this.currentStep = 2;
      } else {
        this.utilisateur = { exists: false };
        this.currentStep = 3;
      }
    },
    () => {
      this.utilisateur = { exists: false };
      this.currentStep = 3;
    }
  );
}

  // Étape 2 : login si le numéro existe
  login() {
    const data = {
      login: this.numeroSansEspaces,
      pwd: this.password,
    };
    this.api.taf_post_login(
      'taf_auth/auth',
      data,
      (reponse: any) => {
        // console.log("Connexion: ", reponse);
        if (reponse.status) {
          this.api.Swal_success('Connexion réussie');
          this.api.save_on_local_storage('token', reponse?.data);
          this.api.save_on_local_storage('les_actions', reponse?.les_actions);
          this.api.update_data_from_token();
          this.api.Swal_success('Opération éffectuée avec succés');
          this.modal.close(reponse);
        } else {
          this.api.Swal_error('Mot de passe incorrect');
        }
      },
      (error: any) => {},
    );
  }

  // Étape 3 : créer un compte si le numéro n'existe pas
  creerCompte() {
    if (!this.isPasswordValid()) {
      this.api.Swal_error(
        'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.',
      );
      return;
    }

    const data = {
      telephone: this.numeroSansEspaces,
      ...this.nouvelUtilisateur,
      id_privilege: 3,
      id_statut_utilisateur: this.desiredPrivilege,
    };

    this.api.taf_post(
      'utilisateur/add2',
      data,
      (reponse: any) => {
        if (reponse.status) {
          this.api.Swal_success('Compte créé avec succès');

          const loginData = {
            login: this.numeroSansEspaces,
            pwd: this.nouvelUtilisateur.password,
          };

          this.api.taf_post(
            'taf_auth/auth',
            loginData,
            async (authRep: any) => {
              if (authRep.status) {
                this.api.Swal_success('Connexion réussie');
                await this.api.save_on_local_storage('token', authRep?.data);
                await this.api.save_on_local_storage(
                  'les_actions',
                  authRep?.les_actions,
                );
                await this.api.update_data_from_token();
                this.modal.close(authRep);
              } else {
                this.api.Swal_error('Erreur de connexion automatique');
                this.modal.close();
              }
            },
            () => {
              this.api.Swal_error('Erreur de connexion automatique');
              this.modal.close();
            },
          );
        } else {
          this.api.Swal_error('Erreur lors de la création du compte');
        }
      },
      (error: any) => {},
    );
  }
}
